var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('MainNav',{attrs:{"current-user":_vm.currentUser}}),_c('v-container',{attrs:{"fluid":""}},[_c('PrintNodeAlert'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }